<template>
  <router-view class="configuration__route"></router-view>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
.configuration__route {
  height: 100%;
}
</style>

<script>
// @flow
export default {
  name: 'configuration'
}
</script>
